<!--  -->
<template>
  <div v-loading="loading">
    <el-form label-position="right" label-width="110px" :model="form">
      <!-- <el-form-item label="企业">
        <el-tag v-if="form.corp_id!=''" style="margin-right:10px">{{ name }} ({{ form.corp_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose('企业')">选择企业</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <el-tag v-for="items,index in form.corp_userid" :key="index" style="margin-right:10px">{{ items.name }} </el-tag>
        <el-button v-if="type === 1" :disabled="form.corp_id===''" type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
        <el-button v-if="type === 2" :disabled="form.corp_id===''" type="primary" size="mini" @click="choose('企业员工')">编辑企业员工</el-button>
      </el-form-item>
      <el-form-item label="公众号">
        <el-tag v-if="form.app_id!=''" style="margin-right:10px">{{ official_name }} ({{ form.app_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose('公众号')">选择公众号</el-button>
      </el-form-item> -->
      <el-form-item label="上传比例">
        <el-input v-model="form.action_set_rate" style="width:200px" placeholder="请输入上传比例" @input="form.action_set_rate = Number(form.action_set_rate.replace(/\D+/, ''))" />
      </el-form-item>
      <el-form-item label="推广帐号id">
        <el-input v-model="form.account_id" style="width:200px" placeholder="请输入推广帐号 id" />
      </el-form-item>
      <!-- <el-form-item label="推广计划id">
        <el-input v-model="form.campaign_id" style="width:200px" placeholder="请输入推广帐号 id" />
      </el-form-item>
      <el-form-item label="推广链接">
        <el-input v-model="form.ad_link" style="width:200px" placeholder="请输入推广链接" />
      </el-form-item> -->
      <el-form-item label="用户行为源类型">
        <el-select v-if="type === 1" v-model="form.type" multiple placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-else v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <!-- <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
      </el-form-item>
      <el-form-item label="用户行为源">
        <el-tag v-if="form.user_action_set_id!=''" style="margin-right:10px">{{ form.user_action_set_id }} </el-tag>
        <el-button type="primary" size="mini" @click="choosebehavioral">选择用户行为源</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="dialogType"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise v-if="dialogType === '请选择企业'" @callback="callback" />
      <official-choose v-if="dialogType === '请选择公众号'" @official="official" />
      <sp-work-choose v-if="dialogType === '请选择企业员工'" ref="workchoose" @spWork="spWork" />
    </el-dialog>
    <el-dialog
      title="选择用户行为源"
      :visible.sync="dialogVisiblebehavioral"
      :append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <behavioralsource ref="behavioralsourceview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from './enterprise.vue'
import behavioralsource from './behavioralsource.vue'
import officialChoose from './officialChoose.vue'
import spWorkChoose from './spWorkChoose.vue'
import bandstaff from '../components/bandstaff.vue'
import { userActioncreate, userActionupdate, userActiondetail } from '@/api/behavioral.js'
export default {
  components: { enterprise, behavioralsource, officialChoose, spWorkChoose, bandstaff },
  data() {
    return {
      dialogVisible: false,
      dialogVisiblebehavioral: false,
      name: '',
      official_name: '',
      worker_name: '',
      form: {
        // corp_id: '',
        action_set_rate: '',
        account_id: '',
        // ad_link: '',
        type: null,
        user_action_set_id: ''
        // corp_userid: [],
        // app_id: '',
        // campaign_id: ''
      },
      options: [{
        value: 'SCANCODE',
        label: '加企业微信客服'
      }, {
        value: 'REGISTER',
        label: '注册'
      },
      {
        value: 'RESERVATION',
        label: '表单预约'
      }, {
        value: 'COMPLETE_ORDER',
        label: '下单'
      }],
      // options: [{
      //   value: 'SCANCODE',
      //   label: '加企业微信客服'
      // }],
      dialogType: null,
      ids: '',
      type: null,
      loading: false,
      dialogVisibler: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    opens(type, id) {
      if (type === 1) {
        this.type = type
        console.log(type)
        console.log('新增')
        this.form.type = []
      } else {
        console.log(type)
        this.type = type
        this.ids = id
        this.form.type = ''
        this.info()
        console.log('编辑')
      }
    },
    choose(type) {
      this.dialogType = `请选择${type}`
      this.dialogVisible = true
      if (type === '企业员工') {
        console.log('111')
        this.$nextTick(() => {
          this.$refs.workchoose.open(this.form.corp_id)
        })
      }
    },
    async info() {
      this.loading = true
      const data = await userActiondetail({
        id: this.ids
      })
      console.log('data', data)
      // this.form.corp_id = data.data.corp_id
      this.form.action_set_rate = data.data.item.action_set_rate
      this.form.account_id = data.data.item.account_id
      // this.form.ad_link = data.data.ad_link
      this.form.type = data.data.item.type
      this.form.user_action_set_id = data.data.item.user_action_set_id
      // this.form.campaign_id = data.data.campaign_id
      // this.form.corp_userid = data.data.corp_userid
      // this.worker_name = data.data.name
      // 企业人员数组
      // const staffarr = [{
      //   name: data.data.name,
      //   user_id: data.data.corp_userid
      // }]
      // this.form.corp_userid = staffarr
      // this.form.app_id = data.data.app_id
      // this.official_name = data.data.account_name
      // this.name = data.data.corp_name
      this.loading = false
      // console.log('data', data)
    },
    callback(item) {
      // console.log(item)
      this.dialogVisible = false
      this.name = item.corp_name
      this.form.corp_id = item.corp_id
    },
    official(item) {
      // console.log(item)
      this.dialogVisible = false
      this.official_name = item.account_name
      this.form.app_id = item.app_id
    },
    spWork(item) {
      console.log(item)
      this.dialogVisible = false
      this.form.corp_userid[0].name = item.name
      this.form.corp_userid[0].user_id = item.user_id
    },
    choosebehavioral() {
      if (this.form.account_id === '') {
        this.$message.error('请输入推广帐号id')
        return
      }
      this.dialogVisiblebehavioral = true
      this.$nextTick(() => {
        this.$refs.behavioralsourceview.open(this.form.account_id, this.form.type)
      })
    },
    updata(item) {
      this.dialogVisiblebehavioral = false
      this.form.user_action_set_id = item
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.corp_userid)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.corp_userid = arr
      console.log(arr)
    },
    // 确定
    async sumbit() {
      // console.log('this.form.corp_userid', this.form.corp_userid)
      // if (this.form.corp_id === '') {
      //   this.$message.error('请选择企业')
      //   return
      // }
      if (this.form.action_set_rate === '') {
        this.$message.error('请输入上传比例')
        return
      }
      if (this.form.account_id === '') {
        this.$message.error('请输入推广帐号id')
        return
      }
      // if (this.form.campaign_id === '') {
      //   this.$message.error('请输入推广计划id')
      //   return
      // }
      if (this.type === 1) {
        if (this.form.type.length === 0) {
          this.$message.error('请选择用户行为源类型')
          return
        }
      } else {
        if (this.form.type === '') {
          this.$message.error('请选择用户行为源类型')
          return
        }
      }

      if (this.form.user_action_set_id === '') {
        this.$message.error('请选择用户行为源')
        return
      }
      // if (this.form.corp_userid === '') {
      //   this.$message.error('请选择企业员工')
      //   return
      // }
      // if (this.form.app_id === '') {
      //   this.$message.error('请选择公众号')
      //   return
      // }
      if (this.type === 1) {
        const data = await userActioncreate(this.form)
        console.log('data', data)
        this.$emit('callback')
      } else {
        const data = await userActionupdate({
          ...this.form,
          id: this.ids
        })
        console.log('data', data)
        this.$emit('callback')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
